import React from 'react';
import './styles/Hero.css';
import heroBackground from './../assets/knife.webp';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero-section" aria-labelledby="hero-title">
        <h2 id="hero-title" className="sr-only">Handcrafted Knives, Built for Adventure</h2>
        <div 
          className='hero'
          role='banner'
        >
          <img loading="eager" src={heroBackground} alt="Custom knife" className="hero-bg-img" fetchpriority="high" />
          <div className="hero-overlay"></div>
          <div className='hero-content'>
            <h1>Precision Handcrafted Knives & Sheaths</h1>
            <p>Expertly crafted custom knives and leather sheaths—designed for precision, durability, and adventure.</p>
            <Link to="/shop-knives/all-knives" className="hero-btn" aria-label="Shop All Products">Browse Now</Link>
          </div>
        </div>
    </section>
  );
};

export default Hero;
